import { RiAddLine } from "@remixicon/react";
import classNames from "classnames";
import React, {
    ReactElement,
} from "react";
import Button, { TableControlsButtonProps } from "./Button";
import Styles from "../Table.module.scss";

const TableControlsCreate = React.forwardRef((
    args: TableControlsButtonProps,
    ref: React.ForwardedRef<HTMLButtonElement>,
): ReactElement => {
    const {
        className,
        variant,
        size,
        text,
        prefixIcon,
        ...rest
    } = args;

    return (
        <Button
            className={classNames(Styles["action-create"], className)}
            prefixIcon={prefixIcon ?? <RiAddLine />}
            variant={variant ?? "primary"}
            size={size ?? "small"}
            ref={ref}
            {...rest}
            text={text}
        />
    );
});

export default TableControlsCreate;
